module.exports = __webpack_public_path__ + "static/media/Transfer.c74dbbf6.png";